/* eslint-disable spellcheck/spell-checker */
const program = require('commander')
const inquirer = require('inquirer')
const pkg = require('../package.json')
const AccountBookParser = require('./accountbookparseradapter')
const colors = require('colors')

const params = [
  {
    type: 'input',
    name: 'filepath',
    message: 'Enter file path account-book:',
    default: './'
  },
  {
    type: 'list',
    name: 'filetype',
    message: 'What app to use ?:',
    choices: [
      'AUTRE',
      'INSPIRE',
      'ODOO',
      'ODOO-COMMUNITY',
      'SAGE',
      'SAGE-i7',
      'SAGE-30',
      'SAGE-COALA'
    ]
  }
]

program
  .version(pkg.name + '@' + pkg.version, '-v, --version')
  .description('=command line for account-book-parser-adapter')
  .action(() => {
    inquirer.prompt(params).then(answers => {
      console.log(
        colors.blue('Parsing en cours du fichier ======>'),
        answers.filepath
      )
      // marque une pause avant le parsing
      setTimeout(function () {
        const parser = new AccountBookParser(
          answers.filepath,
          answers.filetype,
          answers.compagnyid
        )
        // obtenir le parsing
        parser
          .getParser()
          .then(result => {
            // affichage du resultat après parsing
            console.log(colors.green('Parsing effectué avec succès !!!!'))
            let nbrLine = 0
            result.forEach(el => {
              nbrLine += el.values.length
            })
            console.log(
              "Nombre d'element trouvé dans le fichier après parsing ====>",
              nbrLine
            )
          })
          .catch(error => {
            // parsing echoué, affichage de l'erreur
            console.log(
              colors.red('\nErreur de parsing du fichier =====>'),
              answers.filepath
            )
            console.log('\n', error.code, error.message, error.value)
          })
      }, 2000)
    })
  })
program.parse(process.argv)
